import BaseViewController from "./base-view-controller";

class ConsultationDetailViewController extends BaseViewController {
  preprocessScreenData() {
    const { fields } = this.screen;
    const { values } = this.appData;
    fields.forEach(field => {
      const { name, params } = field;
      if (!values[name]) {
        field.params = `${params + (params ? "|" : "")}TDFieldOptionIgnore`;
      }
    });
  }
}

export default ConsultationDetailViewController;
